import { render } from "./view-invoice.vue?vue&type=template&id=22f1b023"
import script from "./view-invoice.vue?vue&type=script&lang=js"
export * from "./view-invoice.vue?vue&type=script&lang=js"

import "./view-invoice.vue?vue&type=style&index=0&id=22f1b023&lang=css"

import exportComponent from "/Users/newuser/Desktop/Development/Node/spider-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__